import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

type Props = {
    onClick: VoidFunction;
    tooltipDisabledContent?: string;
};

const LeadsExcelExportItem = ({ onClick, tooltipDisabledContent }: Props) => {
    const isExportAllowedByClaim = salesSettingsHelper.isExcelAllowed();
    const isExportAllowed = isExportAllowedByClaim && !tooltipDisabledContent;
    const isTrialUserWithoutClaim = !isExportAllowedByClaim && isTrial(swSettings);
    const tooltip = isTrialUserWithoutClaim
        ? translate("si.websites-export.disabled.text")
        : (tooltipDisabledContent ?? translate("si.websites-export.quota-reached.text"));
    return (
        <ExportVariantsDropdownItem
            variant="excel"
            iconName="excel"
            isDisabled={!isExportAllowed}
            text={translate("si.multi_selector.export_options.excel.btn.label")}
            tooltipDisabledContent={<span>{tooltip}</span>}
            onClick={onClick}
        />
    );
};

export default LeadsExcelExportItem;
